// extracted by mini-css-extract-plugin
export var equalColumn = "_hf-0";